import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Tooltip } from 'react-tooltip';

import './index.css';
import './i18n';

import { ErrorBoundary } from '@/components/generic';
import * as Sentry from '@sentry/react';

import App from './App.tsx';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    integrations: [Sentry.replayIntegration()],
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Toaster
      toastOptions={{
        duration: 5000,
        className: 'toasterclass',
      }}
    />
    <Tooltip id='tooltip' className='tooltipclass' />

    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
